import React, { Component } from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import cookie from 'js-cookie'


const decorator = (storeProps) => (ComposedComponent) => {
  class DecoratedComponent extends Component {

    static contextTypes = {
      globals: PropTypes.object,
    }

    data = {}

    UNSAFE_componentWillMount() {
      const { globals, globals: { setRedirectLink } = {} } = this.context || {}

      const props = {
        globals: globals || window.__globals__,
        setRedirectLink,
        redirect: this.redirect,
        getCookieValue: this.getCookieValue,
      }

      if (typeof storeProps === 'function') {
        this.data = storeProps(props, this.props)
      }
      else {
        Object.keys(storeProps).forEach((key) => {
          this.data[key] = storeProps[key](props, this.props)
        })
      }
    }

    getCookieValue = (cookieName) => {
      const { globals } = this.context || {}

      if (globals && globals.cookies) {
        return globals.cookies[cookieName]
      }

      return cookie.get(cookieName)
    }

    redirect = (link) => {
      const { globals: { setRedirectLink } = {} } = this.context || {}

      if (setRedirectLink) {
        setRedirectLink(link)
      }
      else {
        actions.router.replace(link)
      }
    }

    render() {

      return (
        <ComposedComponent
          {...this.props}
          {...this.data}
        />
      )
    }
  }

  return DecoratedComponent
}

export default decorator
